import { __assign } from "tslib";
var cashedToken = "";
var cachedWorkspace = "";
var TOKEN_KEY = "token";
var USER_KEY = "user";
var WORKSPACE_KEY = "workspace";
var REFRESH_TOKEN_KEY = "refreshToken";
var setJwt = function (token, workspace, refreshToken) {
    cashedToken = token;
    cachedWorkspace = workspace;
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(WORKSPACE_KEY, workspace);
    if (refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    }
};
var getJwt = function (includeRefreshToken) {
    var refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
    var sessionToken = cashedToken || localStorage.getItem(TOKEN_KEY);
    if (!sessionToken) {
        return null;
    }
    return ("".concat(sessionToken) +
        "".concat(refreshToken && refreshToken.length && includeRefreshToken !== false ? " ".concat(refreshToken) : ""));
};
var getWorkspace = function () { return cachedWorkspace || localStorage.getItem(WORKSPACE_KEY); };
var injectJwt = function (config) {
    if (config === void 0) { config = {}; }
    var token = getJwt();
    var workspace = getWorkspace();
    var header = token ? { Authorization: token } : {};
    var workspaceHeader = !!workspace ? { workspace: workspace } : {};
    var configHeaders = (config && config.headers) || {};
    return __assign(__assign({}, config), { headers: __assign(__assign(__assign({ "Content-Type": "application/json" }, configHeaders), header), workspaceHeader) });
};
var clearJwt = function () {
    cashedToken = "";
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(WORKSPACE_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
};
export { setJwt, getJwt, injectJwt, clearJwt, getWorkspace };
//# sourceMappingURL=jwt.js.map